import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";
const BrandOrderDetailAnimatedIllustrationPage = lazy(
  () => import("../../pages/BrandOrderDetailAnimatedIllustrationPage")
);
const FaireForecastHubPage = withCompass(
  () => import("../../pages/FaireForecastHubPage")
);

export function SophiaArriolaGibsonRoutes() {
  return (
    <Switch>
      <Route path="/sag/faire-forecast-hub" component={FaireForecastHubPage} />
      <Route
        path="/sag/brand-order-detail-animated-illustration"
        component={BrandOrderDetailAnimatedIllustrationPage}
      />
    </Switch>
  );
}

export const slug = "sag";
